import { render, staticRenderFns } from "./beneficiariosSemConta.vue?vue&type=template&id=6ef22b5a&scoped=true&"
import script from "./beneficiariosSemConta.vue?vue&type=script&lang=js&"
export * from "./beneficiariosSemConta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef22b5a",
  null
  
)

export default component.exports